import { render, staticRenderFns } from "./chatSupportCreate.vue?vue&type=template&id=892ff54c&scoped=true&"
import script from "./chatSupportCreate.vue?vue&type=script&lang=js&"
export * from "./chatSupportCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892ff54c",
  null
  
)

export default component.exports